// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  Toolbar,
  Pagination,
  DateInput,
  DateField,
} from "react-admin";

const DemosRequestsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Rechercher par Id" source="id" alwaysOn />
    <TextInput label="Rechercher par userId" source="userId" alwaysOn />
    <TextInput label="Rechercher par firstName" source="firstName" />
    <TextInput label="Rechercher par lastName" source="lastName" />
    <TextInput label="Rechercher par phone" source="phone" />
    <TextInput label="Rechercher par email" source="email" />
    <DateInput label="Rechercher par date" source="dateDemande" alwaysOn />
  </Filter>
);

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

export const DemosRequestsList = (props) => (
  <List
    {...props}
    filters={<DemosRequestsFilter />}
    pagination={<PostPagination />}
  >
    <Datagrid>
      <TextField source="id" />
      <TextField source="userId" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <TextField source="phone" />
      <TextField source="email" />
      <DateField source="dateDemande" />
      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);

export const DemosRequestsShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="userId" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <TextField source="phone" />
      <TextField source="email" />
      <DateField source="dateDemande" />
    </SimpleShowLayout>
  </Show>
);

export const DemosRequestsEdit = (props) => (
  <Edit {...props}>
    <SimpleForm redirect={false} toolbar={<Toolbar alwaysEnableSaveButton />}>
      <TextInput source="id" />
      <TextInput source="userId" />
      <TextInput source="firstName" />
      <TextInput source="lastName" />
      <TextInput source="phone" />
      <TextInput source="email" />
      <DateInput source="dateDemande" />
    </SimpleForm>
  </Edit>
);
